module.exports = __webpack_public_path__ + "img/滤镜夕阳.7c1de0d4.png";